import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Features.scss';

const Features = () => {
  const navigate = useNavigate();

  const features = [
    {
      image: '/assets/IMG/activites.png',
      title: 'Activités',
      description: 'Programmes de mentorat, ateliers de compétences et événements de réseautage.',
      link: '/programmes'
    },
    {
      image: '/assets/IMG/beneficiaires.png',
      title: 'Bénéficiaires',
      description: 'Étudiants universitaires africains, boursiers et futurs leaders.',
      link: '/beneficiaires'
    },
    {
      image: '/assets/IMG/partenaires.png',
      title: 'Partenaires',
      description: 'Universités, entreprises et fondations engagées pour l\'éducation.',
      link: '/partenaires'
    },
    {
      image: '/assets/IMG/actualites.png',
      title: 'Actualités',
      description: 'Dernières nouvelles, opportunités de bourses et histoires de succès.',
      link: '/actualites'
    }
  ];

  return (
    <section className="features">
      <div className="features-container">
        {features.map((feature, index) => (
          <div
            key={index}
            className="feature-card"
            onClick={() => navigate(feature.link)}
            style={{ cursor: 'pointer' }}
          >
            <div className="feature-icon">
              <img src={feature.image} alt={feature.title} className="feature-image" />
            </div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
